module.exports = __webpack_public_path__ + "static/media/40.eabc2512.jpg";